import { IHttpTokenInterceptor } from "./HttpTokenInterceptor";
import type { AxiosInstance, AxiosRequestHeaders } from "axios";
import type { IStorage } from "@/core/plugins/storage/Storage";
import { DITypes, LocalStorageKeys } from "@/core/@types/types";
import { injectable, inject } from "inversify";
import "reflect-metadata";
@injectable()
export default class AxiosHttpTokenInterceptor
  implements IHttpTokenInterceptor<AxiosInstance>
{
  @inject(DITypes.STORAGE)
  private storage!: IStorage;

  private handlerHeaders(): Partial<AxiosRequestHeaders> {
    return {
      Authorization: `Bearer ${this.storage.get(LocalStorageKeys.Token) || ""}`,
      "Content-Type": "application/json"
    };
  }

  intercept(axios: AxiosInstance): void {
    axios.interceptors.request.use((config) => {
      config.headers = Object.assign({
        ...this.handlerHeaders(),
        ...config.headers
      });

      return config;
    });
  }
}
